import { useEffect, useState } from "react";
import Link from "next/link";
import clsx from "clsx";

import { PARTNER_IDS } from "@chef/constants";
import { Input } from "@chef/components";
import { useAppDispatch, useAppSelector } from "@chef/state-management/hooks";
import { language } from "@chef/constants";
import { getPartnership, setPartnership } from "@chef/state-management";
import { Button } from "@chef/components";

const intl = {
  no: {
    EUROBONUS_NUMBER: "Eurobonus-nummer",
    MUST_BE_EXACTLY_DIGITS: (digit: number) =>
      `Eurobonus-nummeret må være ${digit} sifre`,
  },
  se: {
    EUROBONUS_NUMBER: "Eurobonus-nummer",
    MUST_BE_EXACTLY_DIGITS: (digit: number) =>
      `Eurobonus-numret måste vara exakt ${digit} siffror`,
  },
  dk: {
    EUROBONUS_NUMBER: "Eurobonus-nummer",
    MUST_BE_EXACTLY_DIGITS: (digit: number) =>
      `Eurobonus-nummeret skal være nøjagtigt ${digit} cifre`,
  },
};

export interface EurobonusComponentProps {
  value: {
    text: string;
    href: string;
  };
}

export const EurobonusComponent = ({
  value: { text, href },
}: EurobonusComponentProps) => {
  const dispatch = useAppDispatch();
  const eurobonusPartnership = useAppSelector((state) =>
    getPartnership(state.signupRtk.partnerships, PARTNER_IDS.EUROBONUS),
  );
  const [eurobonusNumber, _setEurobonusNumber] = useState("");
  const [displayError, setDisplayError] = useState("");
  const EUROBONUS_NUMBER_LENGTH = 9;

  const setEurobonusNumber = (value: string) => {
    const numericValue = value.replace(/[^0-9]/g, "");
    _setEurobonusNumber(numericValue);
  };

  const validateEurobonusNumber = () => {
    const isInvalid = eurobonusNumber.length !== EUROBONUS_NUMBER_LENGTH;

    if (isInvalid) {
      setDisplayError(
        intl[language].MUST_BE_EXACTLY_DIGITS(EUROBONUS_NUMBER_LENGTH),
      );
    }
  };

  useEffect(() => {
    if (eurobonusNumber.length === EUROBONUS_NUMBER_LENGTH) {
      dispatch(
        setPartnership({
          partnerId: PARTNER_IDS.EUROBONUS,
          customerReference: eurobonusNumber,
        }),
      );
    }
  }, [eurobonusNumber, dispatch]);

  return (
    <div className="flex flex-col gap-4">
      <Input
        placeholder={intl[language].EUROBONUS_NUMBER}
        name="eurobonusNumber"
        id="eurobonusNumber"
        value={eurobonusNumber}
        onChange={(e) => setEurobonusNumber(e.target.value)}
        showLengthCounter
        maxLength={EUROBONUS_NUMBER_LENGTH}
        valid={!!eurobonusPartnership}
        error={displayError}
      />
      <Link
        href={eurobonusNumber.length === EUROBONUS_NUMBER_LENGTH ? href : "#"}
        className={clsx("w-full md:w-auto md:self-center", "no-underline")}
        passHref
      >
        <Button primary className="w-full" onClick={validateEurobonusNumber}>
          {text}
        </Button>
      </Link>
    </div>
  );
};
